import React from 'react'
import Typography from '@mui/material/Typography'
import useStyles from '../_styles'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { ConsentStepProps } from '../_props'
import clsx from 'clsx'
import { ErrorRoundedIcon } from 'apps/ids/src/app/assets/icons/icons'
import { getCivilityLabel } from '../../../Patient/History/_utils'

export default function ConsentStep({
    patient,
    consentGiven,
    onConsentChange,
}: ConsentStepProps) {
    const classes = useStyles()
    const prepPhrase = patient?.patientData?.sex?.toUpperCase() === 'F' ? 'de la patiente' : 'du patient'
    const patientSex = patient?.patientData?.sex || null
    const patientName = patient?.patientData?.fullName || patient?.patientLibelle?.split(' (')[0] || ''
    const patientCivility = getCivilityLabel(patientSex)

    return (
        <div className={classes.stepContent}>
            <div className={classes.consentHeader}>
                <Typography className={classes.consentTitle}>
                    Avez-vous récolté le consentement {prepPhrase}, {patientCivility} {patientName} ?
                </Typography>
            </div>
            <div className={classes.consentCards}>
                <button
                    type="button"
                    onClick={() => onConsentChange(false)}
                    className={clsx(classes.consentCard, {
                        [classes.consentCardError]: consentGiven === false,
                        [classes.consentCardNoHoverRed]: consentGiven === false,
                    })}
                >
                    <div className={classes.consentCardContent}>
                        <div>
                            <div className={classes.consentCardTitle}>Non</div>
                            <div className={classes.consentCardText}>Sans le consentement du patient, il ne sera pas possible de poursuivre l'initiation de l'acte</div>
                        </div>
                        {consentGiven === false && (
                            <ErrorRoundedIcon className={classes.errorRoundedIcon}/>
                        )}
                    </div>
                </button>
                <button
                    type="button"
                    onClick={() => onConsentChange(true)}
                    className={clsx(classes.consentCard, {
                        [classes.consentCardSelected]: consentGiven === true
                    })}
                >
                    <div className={classes.consentCardContent}>
                        <div>
                            <div className={classes.consentCardTitle}>Oui</div>
                            <div className={classes.consentCardText}>Je certifie avoir récolté auprès du patient, son consentement libre, conscient et éclairé</div>
                        </div>
                        {consentGiven === true && (
                            <CheckCircleIcon className={classes.consentCheckIcon} />
                        )}
                    </div>
                </button>
            </div>
        </div>
    )
}
